import React, { FC } from 'react';
import styled from 'styled-components';
import Theme, { default as theme } from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { CellProps } from '../../../utils';

const NameContainer = styled.div({
  width: '100%',
});

const AddressText = styled.span({
  ...Theme.typography.bodySmall,
  color: theme.colors.charcoal700,
});

export const NameCell: FC<CellProps> = ({ row, value }) => {
  return (
    <NameContainer data-testid={`ProjectName:${row.original.id}`}>
      <OverflowTooltip triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}>
        {value}
      </OverflowTooltip>
      {row.original.addressLine1 && (
        <OverflowTooltip
          triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}
          content={row.original.addressLine1}
        >
          <AddressText>{row.original.addressLine1} </AddressText>
        </OverflowTooltip>
      )}
    </NameContainer>
  );
};
